import React from 'react';

import * as actionsTrip from '../../store/actions/trip';
import * as tripHelper from '../../utils/tripHelper';
import {getQuery} from '../../utils/url';
import * as navigator from '../../utils/navigator';
import {show as showLoading} from '../../components/Loading';
import toast from '../../components/toast';
import {setTitle} from '../../utils/compatible';
import {TYPE, isPreview} from '../../utils/type';

import './Footer.css';

const query = getQuery();


export default class Footer extends React.Component {

  handleClick = () => {
    let {poi, trip, city} = this.props;
    let day = parseInt(query.day, 10);
    let step = query.step ? parseInt(query.step, 10) : 1;

    if (this.isAdded()) {
      trip = tripHelper.deletePoi(trip, poi.poi_uid, tripHelper.type.isHotel(poi) ? query.day : false);
    } else {

      let checkResult = tripHelper.checkAddPoi(trip, poi, day);
      if (checkResult !== true) {
        return toast(checkResult.message);
      }

      trip = tripHelper.addPoi(trip, poi, day, city);
    }

    switch (TYPE) {
      case 'create':
        actionsTrip.editTrip(trip, actionsTrip.editTrip.targets[0]);
        navigator.back(-step);
        break;
      case 'edit':
        actionsTrip.editTrip(trip, actionsTrip.editTrip.targets[1]);
        navigator.back(-step);
        break;
      case 'select-attraction':
        actionsTrip.editTrip(trip, actionsTrip.editTrip.targets[2]);
        navigator.back(-step);
        break;
      default:
        let hide = showLoading();
        actionsTrip.asyncSaveTrip(trip.trip_id, trip).then(function () {
          hide();
          navigator.back(-step);
        }).catch(function (err) {
          hide();
          toast(err.message);
        });
    }
  };

  isAdded() {
    let {poi, trip} = this.props;

    // 多天可以添加同一酒店，判断酒店是否已添加时，要加当前天参数，非酒店时不加
    if (tripHelper.type.isHotel(poi)) {
      return tripHelper.existPoi(trip, poi.poi_uid, query.day);
    } else {
      return tripHelper.existPoi(trip, poi.poi_uid);
    }
  }

  render() {
    let {poi, trip} = this.props;

    if (!trip || isPreview) {
      return null;
    }

    let isAdded = this.isAdded();

    // 不是酒店，且已添加，则不出现删除按钮。
    if (!tripHelper.type.isHotel(poi) && isAdded) {
      return null;
    }


    return (
      <footer
        className="footer"
        onClick={this.handleClick}>
        <i className="icon icon-add"></i>
        <div className="add-to-trip-btn">{isAdded ? '已' : ''}加入行程</div>
      </footer>
    );
  }

  componentDidMount() {
    let {poi} = this.props;

    setTitle(poi.info.cn_name);
  }
}



// WEBPACK FOOTER //
// ./src/pages/poi2/Footer.js